/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./animate-arrows.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./animate-arrows.component";
var styles_AnimateArrowsComponent = [i0.styles];
var RenderType_AnimateArrowsComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AnimateArrowsComponent, data: {} });
export { RenderType_AnimateArrowsComponent as RenderType_AnimateArrowsComponent };
export function View_AnimateArrowsComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "div", [["class", "arrow"]], null, null, null, null, null))], null, null); }
export function View_AnimateArrowsComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "sc-animate-arrows", [], null, null, null, View_AnimateArrowsComponent_0, RenderType_AnimateArrowsComponent)), i1.ɵdid(1, 114688, null, 0, i2.AnimateArrowsComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AnimateArrowsComponentNgFactory = i1.ɵccf("sc-animate-arrows", i2.AnimateArrowsComponent, View_AnimateArrowsComponent_Host_0, {}, {}, []);
export { AnimateArrowsComponentNgFactory as AnimateArrowsComponentNgFactory };
